import _construct from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import chroma from '../../chroma.js';
import Color from '../../Color.js';
import input from '../input.js';
import temperature2rgb from './temperature2rgb.js';
import rgb2temperature from './rgb2temperature.js';
Color.prototype.temp = Color.prototype.kelvin = Color.prototype.temperature = function () {
  return rgb2temperature(this._rgb);
};
var temp = function temp() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return _construct(Color, args.concat(['temp']));
};
Object.assign(chroma, {
  temp: temp,
  kelvin: temp,
  temperature: temp
});
input.format.temp = input.format.kelvin = input.format.temperature = temperature2rgb;
export { temp, temp as kelvin, temp as temperature };